<div class="tag-menu">
  @for (label of labels; track label; let i = $index) {
    <div
      class="menu-item"
      [ngStyle]="selectedIndex == i ? selectedStyle : unselectedStyle"
      (click)="clickItem(i)"
    >
      {{ label }}
    </div>
  }
</div>
